/*
This file was generated by the Surface compiler.
*/

import debounce from "lodash.debounce"
const debounceMilliseconds = 500

export const autocomplete = {
  displayInput: null,
  itemClicked: false,
  fetcherFunction: null,
  touched: false,
  cancelled: false,

  async mounted() {
    this.displayInput = this.el.querySelector('input[type="text"]')
    this.debouncedShowOptionsForQuery = debounce(
      this.showOptionsForQuery.bind(this),
      debounceMilliseconds,
    )
    this.displayInput.addEventListener("blur", (e) => {
      if (!this.itemClicked && this.touched) {
        this.displayInput.dispatchEvent(
          new CustomEvent("autocomplete:leaving", {
            bubbles: true,
          }),
        )
        this.clear_dropdown()
        this.cancelled = true
      }
      e.stopImmediatePropagation()
      this.itemClicked = false
      this.touched = false
    })
    this.displayInput.addEventListener("change", (e) => {
      e.stopImmediatePropagation()
    })
    await waitFor(() => window.hasOwnProperty(this.el.dataset.getItems), 2000)
    this.fetcherFunction = window[this.el.dataset.getItems]
    this.displayInput.addEventListener("input", () => {
      this.touched = true
      this.debouncedShowOptionsForQuery()
    })
  },
  destroyed() {
    // Do nothing if we're already destroyed
    this.debouncedShowOptionsForQuery.cancel()
  },
  async showOptionsForQuery() {
    const query = this.displayInput.value
    const results = await this.fetcherFunction(query)
    if (results.length == 0 || this.cancelled) {
      this.cancelled = false
      return this.clear_dropdown()
    }

    const ul = this.el.querySelector("ul")
    const li_template = this.el.querySelector("template")
    const li_elms = results.map((result) => {
      let li = li_template.content.cloneNode(true)
      let imgTag = li.querySelector("img")

      if (result.imageUrl) {
        imgTag.src = result.imageUrl
      } else {
        imgTag && imgTag.remove()
      }

      li.querySelector("span").textContent = result.optionText
      // mousedown must be used in order to handle the click before the blur
      li.firstElementChild.addEventListener("mousedown", (e) => {
        this.itemClicked = true

        this.displayInput.value = result.selectionText
        ul.dispatchEvent(
          new CustomEvent("autocomplete:item-select", {
            detail: result,
            bubbles: true,
          }),
        )
        this.clear_dropdown()
      })
      return li
    })

    ul.style.display = "block"
    ul.innerHTML = ""
    li_elms.forEach((li_elm) => {
      ul.appendChild(li_elm)
    })
    this.displayInput.setAttribute("aria-expanded", "true")
  },

  clear_dropdown() {
    const ul = this.el.querySelector("ul")
    ul.innerHTML = ""
    ul.style.display = "none"
    this.displayInput.setAttribute("aria-expanded", "false")
  },
}

async function waitFor(predicate, timeout) {
  return new Promise((resolve, reject) => {
    const check = () => {
      if (!predicate()) return
      clearInterval(interval)
      resolve()
    }
    const interval = setInterval(check, 100)
    check()

    if (!timeout) return
    setTimeout(() => {
      clearInterval(interval)
      reject()
    }, timeout)
  })
}
